import React from 'react';
import _ from 'lodash';
import TableContext from './TableContext';
import { mergeColumnConfigs } from './column';

class TableProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: null,
      sorting: props.defaultSorting,
      selected: [],
      columnFilters: []
    };
    this.columns = mergeColumnConfigs(props.columns);
  }

  setSelected = selected => {
    this.setState({ selected });
  };

  isRowSelected = id => {
    const { selected } = this.state;
    return selected.includes(id);
  };

  toggleSelected = id => {
    const { selected } = this.state;
    if (selected.includes(id)) {
      this.setSelected(selected.filter(selectedId => selectedId !== id));
    } else {
      this.setSelected(_.concat(selected, id));
    }
  };

  clearSelected = () => {
    this.setSelected([]);
  };

  getColumnFilter = columnName => {
    const { columnFilters } = this.state;
    return _.find(columnFilters, { columnName });
  };

  setColumnFilter = (columnName, values = []) => {
    const { columnFilters: currentColumnFilters } = this.state;
    const columnFilter = { columnName, values };
    const columnFilters = currentColumnFilters.filter(
      filter => filter.columnName !== columnName
    );
    columnFilters.push(columnFilter);
    this.setState({ columnFilters, selected: [] });
  };

  clearColumnFilters = () => {
    this.setState({ columnFilters: [], selected: [] });
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('search')) {
      this.setState({ query: searchParams.get('search') });
    }
  }

  render() {
    const { children, data, selectable, onRowClick } = this.props;
    const { query, sorting, selected, columnFilters } = this.state;
    const { columns } = this;
    return (
      <TableContext.Provider
        value={{
          // Data in the table, array where each object is one row
          data,

          // Columns in the table (configurations)
          columns,

          // Query term globally for the table
          query,
          setQuery: q => {
            this.setState({ query: q, selected: [] });
          },
          isQueryActive: query && query.length > 1,

          // Column filtering
          // Format: { columnName: '...', values: [...] }
          // Example: { columnName: 'category', values: ['Desserts', 'Main Courses'] }
          columnFilters,
          getColumnFilter: this.getColumnFilter,
          setColumnFilter: this.setColumnFilter,
          clearColumnFilters: this.clearColumnFilters,

          // On click row
          onRowClick,

          // Sorting
          sorting,
          setSorting: (columnName, direction) => {
            this.setState({ sorting: [{ columnName, direction }] });
          },
          getSortingForColumn: columnName => {
            const sortColumn = sorting.filter(
              sortEntry => sortEntry.columnName === columnName
            );
            return sortColumn.length > 0 ? sortColumn[0].direction : null;
          },

          // Selected rows
          // -- Is selection activated
          selectable,
          // -- Selected rows
          selected,
          setSelected: this.setSelected,
          clearSelected: this.clearSelected,
          isRowSelected: this.isRowSelected,
          toggleSelectObject: this.toggleSelected
        }}
      >
        {children}
      </TableContext.Provider>
    );
  }
}

export default TableProvider;
